export default __webpack_public_path__ + "9dfcad32f03bfbbe22996c86c3d7a5b0.png";